import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { ErrorToastrComponent } from '../components/custom-toastr/error/error-toastr.component';
import { InfoToastrComponent } from '../components/custom-toastr/info/info-toastr.component';
import { SuccessToastrComponent } from '../components/custom-toastr/success/success-toastr.component';
import { WarningToastrComponent } from '../components/custom-toastr/warning/warning-toastr.component';

@Injectable({
  providedIn: 'root'
})
export class CustomToastrService {
  constructor(private toastr: ToastrService) {}

  // Toastr format for successful action notifications.
  showSuccess(message: string, durationMS: number = 3000): void {
    this.toastr.show(message, "", {
      toastComponent: SuccessToastrComponent,

      // Do not comment/remove  the line below, otherwise it would
      // lead to black shadow artifacts around the toastr component.
      toastClass: 'toast-custom',

      positionClass: 'toast-top-center',
      timeOut: durationMS,
      closeButton: false,
      enableHtml: true,
      tapToDismiss: false,
      disableTimeOut: false
    });
  }

  // Toastr format for error notifications.
  showError(message: string, durationMS: number = 5000): void {
    this.toastr.show(message, "", {
      toastComponent: ErrorToastrComponent,

      // Do not comment/remove  the line below, otherwise it would
      // lead to black shadow artifacts around the toastr component.
      toastClass: 'toast-custom',

      positionClass: 'toast-top-center',
      timeOut: durationMS,
      closeButton: false,
      enableHtml: true,
      tapToDismiss: false,
      disableTimeOut: false
    });
  }

  // Toastr format for informative notifications.
  showInfo(message: string, durationMS: number = 3000): void {
    this.toastr.show(message, "", {
      toastComponent: InfoToastrComponent,

      // Do not comment/remove  the line below, otherwise it would
      // lead to black shadow artifacts around the toastr component.
      toastClass: 'toast-custom',
      
      positionClass: 'toast-top-center',
      timeOut: durationMS,
      closeButton: false,
      enableHtml: true,
      tapToDismiss: false,
      disableTimeOut: false
    });
  }

  // Toastr format for warning notifications.
  showWarning(message: string, durationMS: number = 3000): void {
    this.toastr.show(message, "", {
      toastComponent: WarningToastrComponent,

      // Do not comment/remove  the line below, otherwise it would
      // lead to black shadow artifacts around the toastr component.
      toastClass: 'toast-custom',
      
      positionClass: 'toast-top-center',
      timeOut: durationMS,
      closeButton: false,
      enableHtml: true,
      tapToDismiss: false,
      disableTimeOut: false
    });
  }
}
